import React from "react";
import dynamic from "next/dynamic";
import Section from "@/Components/LayoutComponents/Section";

// Disable SSR for client-only components
const IndustryTabs = dynamic(() => import("./CaseStudiesTabs"));
const IndustryTabsGreen = dynamic(() => import("./CaseStudiesTabsGreen"));

export interface CaseStudiesBlockProps {
  data?: any;
}

const OurApproach: React.FC<CaseStudiesBlockProps> = ({ data }) => {
  const length = data?.points?.length / 2;
  const points = data?.points.slice(0, length);
  const points2 = data?.points.slice(length, data?.points?.length);
  return (
    <Section>
      <div className="container">
        <div className="xl:max-w-[910px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 font-regular mt-3">
            {data?.short_title}
          </p>
        </div>
        <div className="xl:mt-10 mt-8">
          <IndustryTabs CaseCard={points} />
        </div>
        <div className="xl:mt-16 mt-8">
          <IndustryTabsGreen CaseCard={points2} />
        </div>
      </div>
    </Section>
  );
};
export default OurApproach;
